import {useEffect, useMemo, useState} from 'react';
import {useSelector} from 'react-redux';
import {selectAccountsById} from '../../../store/accounts';
import {findAllMovements} from '../../../api/moneyMovement';
import TransactionItem from '../../TransactionsPage/components/TransactionItem';
import {groupByDate} from '../../TransactionsPage/utils/mathUtils';
import {formatGroupDate} from '../../TransactionsPage/utils/dateUtils';
import '../../TransactionsPage/TransactionsPage.scss';

// key={project.id} must be set by the parent to reset state on project switch
const ProjectTransactions = ({project}) => {
    const accountsById = useSelector(selectAccountsById);
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        findAllMovements({projectIds: [project.id]})
            .then(setItems)
            .finally(() => setLoading(false));
    }, [project.id]);

    const grouped = useMemo(() => groupByDate(items), [items]);

    return (
        <div className="entity-detail__section">
            <h4 className="entity-detail__subtitle">Transactions</h4>
            <div className="project-tx-list">
                {grouped.map(group => (
                    <div key={group.date} className="tx-date-group">
                        <div className="tx-date-header">{formatGroupDate(group.date)}</div>
                        {group.items.map(item => (
                            <TransactionItem key={`${item.type}-${item.id}`} item={item} accountsById={accountsById}/>
                        ))}
                    </div>
                ))}
                {loading && <p className="project-tx-status">Loading…</p>}
                {!loading && items.length === 0 && (
                    <p className="project-tx-status">No transactions found.</p>
                )}
            </div>
        </div>
    );
};

export default ProjectTransactions;
